export const yardTrackTypes = ["Yard Track", "RAR Track", "Yard Track 1", "Yard Track 2", "Yard Track 3"];



// WEBPACK FOOTER //
// ./src/AssetTypeConfig/WorkplanTemplate/WorkPlanAdd.js